import { isPlatformBrowser } from '@angular/common';
import { Component, Inject, OnInit, PLATFORM_ID } from '@angular/core';
import { RouterModule } from '@angular/router';
import { CookiesService } from '../../services/cookies.service';

@Component({
    selector: 'app-footer',
    imports: [RouterModule],
    templateUrl: './footer.component.html',
    styleUrl: './footer.component.css'
})
export class FooterComponent implements OnInit {
  private readonly isBrowser: boolean;

  constructor(
    @Inject(PLATFORM_ID) platformId: object,
    private readonly cookiesServiceManual: CookiesService
  ) {
    this.isBrowser = isPlatformBrowser(platformId);
  }

  ngOnInit(): void {
    if (!this.isBrowser) {
      return;
    }

    // Si no se aceptaron las cookies personalizadas, mostramos la barra de aceptación
    if (!this.cookiesServiceManual.personalizacionAceptada()) {
      this.cookiesServiceManual.mostrarBarraAceptacion(true);
    }

  }

 
  onPonerCookie(tipo: string = 'default'): void {
    this.cookiesServiceManual.ponerCookie(tipo);
  }
}
